export default __webpack_public_path__ + "static/media/man.78db91d1.jpg";